export default "__VITE_ASSET__CKRPzi9l__"